import React, { useState } from "react";
import { ConsumptionKpiCards } from "./KpiCard";
import { ConsumptionChart } from "./ConsumptionChart";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@shared/ui/select";
import { Droplet } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useService } from "../../../dashboard/hook";
import { getLoginDataFromStorage } from "@shared/utils/loginUtils";

export const ConsumptionView = () => {
  const { t } = useTranslation();
  const [periodFilter, setPeriodFilter] = useState("fetch_last_six_records");
  
  const { consumerId } = getLoginDataFromStorage();
  const { data: serviceData } = useService({ consumer: consumerId });
  const activeServices = React.useMemo(() => serviceData?.result || [], [serviceData]);

  const [utilityFilter, setUtilityFilter] = useState("");

  React.useEffect(() => {
    if (activeServices.length > 0 && !utilityFilter) {
      setUtilityFilter(activeServices[0]);
    }
  }, [activeServices, utilityFilter]);

  return (
    <div className="space-y-6 pt-4">
      <div className="flex items-center justify-end gap-3 mb-2">
        <Select value={periodFilter} onValueChange={setPeriodFilter}>
          <SelectTrigger className="w-auto  ">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="fetch_last_one_record">{t("1 Month")}</SelectItem>
            <SelectItem value="fetch_last_three_records">{t("3 Months")}</SelectItem>
            <SelectItem value="fetch_last_six_records">{t("6 Months")}</SelectItem>
            <SelectItem value="fetch_last_twelve_records">{t("1 Year")}</SelectItem>
          </SelectContent>
        </Select>

        <Select value={utilityFilter} onValueChange={setUtilityFilter}>
          <SelectTrigger className="w-auto">
            <SelectValue placeholder="Select utility" />
          </SelectTrigger>
          <SelectContent>
            {activeServices.map((service: string, index: number) => {
              return (
                <SelectItem key={index} value={service}>
                  <div className="flex items-center gap-2">
                    <span>{service}</span>
                  </div>
                </SelectItem>
              );
            })}
          </SelectContent>
        </Select>
      </div>

      <ConsumptionKpiCards />
      <ConsumptionChart utilityFilter={utilityFilter} periodFilter={periodFilter} />
    </div>
  );
};
